<template>
  <v-app>
    <v-toolbar class="indigo" dark fixed app dense app :clipped-left="primaryDrawer.clipped">
      <v-toolbar-side-icon @click.stop="sideNav = !sideNav"></v-toolbar-side-icon>
      <v-toolbar-title>{{$CONFIG.APP_TITLE}}</v-toolbar-title>
    </v-toolbar>
    <v-navigation-drawer
      persistent
      v-model="sideNav"
      enable-resize-watcher
      app
      :permanent="primaryDrawer.type === 'permanent'"
      :persistent="primaryDrawer.type === 'persistent'"
      :temporary="primaryDrawer.type === 'temporary'"
      :clipped="primaryDrawer.clipped"
      :floating="primaryDrawer.floating"
      :mini-variant.sync="primaryDrawer.mini"
    >
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img src="static/img/logo.png" >
          </v-list-tile-avatar>
          <v-list-tile-content>
            <span class="indigo--text text-xs-center">UNIVERSITAS TERBUKA <br><small>Making Higher Education</small></span>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.native.stop="primaryDrawer.mini = !primaryDrawer.mini">
              <v-icon color="indigo lighten-1">chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>

      <v-toolbar flat class="indigo darken-1 transparent" dark>
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar >
              <v-icon class="white--text">fa-user-circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content class="white--text">
              <small>Pengguna:</small>
              <v-list-tile-title><b>{{ userinfo.nama_lengkap }}</b></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-list class="pt-0"  dense>
        <v-divider></v-divider>
        <template v-for="item in menuItems" >
          <v-list-group v-if="item.title" >
            <v-list-tile slot="item" :key="item.title" router :to="item.link">
              <v-list-tile-action>
                <v-icon color="indigo lighten-1">{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="blue--text">{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="item.items">
                <v-icon color="blue lighten-1">keyboard_arrow_down</v-icon>
              </v-list-tile-action>
            </v-list-tile>

            <template v-for="subItem in item.items">
              <v-list-tile v-if="subItem.title" :key="subItem.title" router :to="subItem.link">
                <v-list-tile-action>
                  <v-icon color="blue lighten-1">{{ subItem.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title class="blue--text">{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-else-if="subItem.divider"></v-divider>
            </template>
          </v-list-group>
          <v-divider v-else-if="item.divider"></v-divider>
          <v-subheader class="indigo--text title"  v-else-if="item.header" v-text="item.header"></v-subheader>
        </template>
      </v-list>

    </v-navigation-drawer>
    <main>
      <v-content>
        <router-view>
          <v-container fluid></v-container>
        </router-view>
      </v-content>
    </main>

    <v-footer class="indigo" app>
      <span class="white--text text-right" >{{footer.label}} &copy;{{footer.year}} </span>
    </v-footer>
  </v-app>
</template>

<script>
  export default{
    created () {
    },
    mounted () {
      this.$router.push('/main/pesertaujian')
    },
    data () {
      return {
        userinfo: {
          username: '',
          nama_lengkap: ''
        },
        sideNav: true,
        drawers: ['Permanent', 'Persistent', 'Temporary'],
        primaryDrawer: {
          model: true,
          type: 'persistent',
          clipped: true,
          floating: false,
          mini: false
        },
        menuItems: [
          { header: 'Menu Utama' },
          { name: 'pesertaujian', title: 'Cari Peserta Ujian', icon: 'fa-list', link: '/main/pesertaujian' },
          { divider: true }
        ],
        profileItems: [
          { icon: 'contacts', title: 'Profile' }
        ],
        footer: {
          label: 'ICT-Pusjian',
          year: this.$moment().format('YYYY')
        }
      }
    },
    methods: {
      clickMenu (name) {
      },
      onLogout () {
        this.$store.commit('clearAuth')
        this.$router.push('/login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src_suopass/pages/Main.vue